import { validationMessages } from '../../translations'

export function passwordConfirmation(password, passwordConfirmation, formatMessage = undefined) {
  const error =
    (formatMessage && formatMessage(validationMessages.passwordConfirmation)) ||
    'Passwords do not match.'
  if (password !== passwordConfirmation) return error
}
